module.exports = __webpack_public_path__ + "static/media/results_archive_btn.0aff50c0.svg";